export const isLogin = () => !!localStorage.getItem("beMyStoryToken");
